import React from 'react';
import Plx from 'react-plx';

import StyledCurtain from './curtain.style';

const Curtain = () => {
  // const [curtainRightTranslate, setCurtainRightTranslate] = useState(2000);
  // const [curtainLeftTranslate, setCurtainLeftTranslate] = useState(2000);

  // const handleCurtainPosition = () => {
  //   if (window.pageYOffset * 2 < window.innerHeight) {
  //     setCurtainLeftTranslate(window.pageYOffset * 2);
  //     setCurtainRightTranslate(window.pageYOffset * 4);
  //   }
  // };

  // useEffect(() => {
  //   handleCurtainPosition();

  //   window.addEventListener('scroll', throttle(handleCurtainPosition));

  //   return () => window.removeEventListener('scroll', throttle(handleCurtainPosition));
  // });
  const leftCurtain = [
    {
      start: 50,
      duration: '100vh',
      easing: 'easeInOut',
      properties: [
        {
          startValue: 0,
          endValue: 200,
          property: 'translateY'
        },
        {
          startValue: 0,
          endValue: -200,
          property: 'translateX'
        },
        {
          startValue: 15,
          endValue: 90,
          property: 'rotate'
        }
      ]
    }
  ];
  const rightCurtain = [
    {
      start: 0,
      duration: '100vh',
      easing: 'easeInOut',
      properties: [
        {
          startValue: 0,
          endValue: 200,
          property: 'translateY'
        },
        {
          startValue: 0,
          endValue: 200,
          property: 'translateX'
        },
        {
          startValue: -50,
          endValue: -90,
          property: 'rotate'
        }
      ]
    }
  ];
  return (
    <StyledCurtain>
      <Plx parallaxData={leftCurtain} className="curtain__left" />
      <Plx parallaxData={rightCurtain} className="curtain__right" />
    </StyledCurtain>
  );
};

export default Curtain;
